import { Component } from '@angular/core';
import { environment } from '@benefitsui/environments/environment';
import { Location } from '@angular/common';
import { Defaults } from '../../shared/defaults/defaults';

@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss']
})
export class NotFoundPageComponent {
  constructor(private location: Location) {}

  contactPhone = Defaults.contactUsNumber;
  homeLink = environment.loginUrl;

  goToHome() {
    this.location.historyGo(-2);
  }
}
